import ServiceStore from "stores/ServiceStore";
import { RouteType } from "types/RouteType";

const ProjectBidProposalWorkflowRoute: RouteType = {
  name: "Project Bid Proposal Workflow",
  path: "/workflows/project-bid-proposal",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Project Bid & Proposal Generator",
      component: () => import("./ProjectBidProposalWorkflowHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./ProjectBidProposalWorkflow"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load necessary data for the wizard
      const customerRfqsStore = rootStore.customerRfqsStore as ServiceStore;
      const productsStore = rootStore.productsStore as ServiceStore;
      const materialsStore = rootStore.materialsStore as ServiceStore;
      const contactsStore = rootStore.contactsStore as ServiceStore;
      const accountsStore = rootStore.accountsStore as ServiceStore;

      await Promise.all([
        customerRfqsStore?.find(),
        productsStore?.find(),
        materialsStore?.find(),
        contactsStore?.find(),
        accountsStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for project bid proposal:", error);
      return false;
    }
  },
  onExit: ({ rootStore }) => {
    // Reset the wizard state when leaving
    const store = (rootStore as any).projectBidProposalWorkflowStore;
    store?.reset();
  },
};

export default ProjectBidProposalWorkflowRoute;